import { Facebook, Twitter, Instagram, Youtube, Globe, ShieldCheck, Phone, Mail, MapPin } from "lucide-react";
import { FOOTER_COLUMNS } from "@/data/content";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="bg-[#172441] text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-10">
          {/* Brand */}
          <div className="col-span-2 md:col-span-3 lg:col-span-1">
            <div className="flex">
              <Logo />
            </div>
            <p className="text-sm text-white/60 mt-5 leading-relaxed max-w-xs">
              Radio App Consultancy is an independent consultancy for radio, web, mobile apps, custom software and antivirus. We deliver for a one-time charge — no subscription, ever.
            </p>
            <span className="mt-5 inline-flex items-center gap-2 text-xs font-semibold text-[#3B82F6]">
              <ShieldCheck className="h-4 w-4" /> Independent Consultancy
            </span>

            <div className="mt-5 space-y-2.5">
              <span className="flex items-start gap-2.5 text-sm text-white/70" data-testid="footer-address">
                <MapPin className="h-4 w-4 text-[#3B82F6] mt-0.5 shrink-0" />
                <span><span className="text-white/50">USA:</span> 1250 Poinsett Hwy, Greenville, SC 29609</span>
              </span>
              <span className="flex items-start gap-2.5 text-sm text-white/70" data-testid="footer-address-india">
                <MapPin className="h-4 w-4 text-[#3B82F6] mt-0.5 shrink-0" />
                <span><span className="text-white/50">India:</span> Flat No. 40 B, Motia City, Zirakpur, Punjab 140603</span>
              </span>
              <a href="tel:+18644810776" className="flex items-center gap-2.5 text-sm text-white/70 hover:text-[#3B82F6] transition-colors" data-testid="footer-phone">
                <Phone className="h-4 w-4 text-[#3B82F6]" /> (864) 481-0776
              </a>
              <a href="mailto:akarjagdev@gmail.com" className="flex items-center gap-2.5 text-sm text-white/70 hover:text-[#3B82F6] transition-colors" data-testid="footer-email">
                <Mail className="h-4 w-4 text-[#3B82F6]" /> akarjagdev@gmail.com
              </a>
            </div>
            <div className="flex items-center gap-3 mt-5">
              {[Facebook, Twitter, Instagram, Youtube].map((Icon, i) => (
                <a key={i} href="#" className="h-9 w-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#3B82F6] hover:text-[#0F172A] transition-colors" aria-label="social">
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          {FOOTER_COLUMNS.map((col) => (
            <div key={col.title}>
              <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-white/50">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l}><a href="#" className="text-sm text-white/70 hover:text-[#3B82F6] transition-colors">{l}</a></li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <p className="text-xs text-white/40 mt-10 leading-relaxed max-w-4xl" data-testid="footer-disclaimer">
          Radio App Consultancy is an independent third-party consultancy offering expert consultation and
          one-time delivery across radio, web, apps, software and antivirus. We charge a one-time service fee and do not offer any subscription
          or recurring billing. If any issue arises within 15 days of delivery, we fix it free of charge. We are not
          affiliated with, endorsed by, or sponsored by any brand, and all product names, logos, and trademarks are the
          property of their respective owners.
        </p>
        <p className="text-xs text-white/35 mt-3" data-testid="footer-parent-line">
          Radio App Consultancy is a part of Savi Services.
        </p>

        <div className="mt-6 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-white/50">
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <span>© {new Date().getFullYear()} Radio App Consultancy. Independent Consultancy.</span>
            <a href="/terms" className="hover:text-white">Terms of Service</a>
            <a href="/refund" className="hover:text-white">Refund Policy</a>
            <a href="/privacy" className="hover:text-white">Privacy Policy</a>
            <a href="#" className="hover:text-white">Accessibility</a>
          </div>
          <span className="inline-flex items-center gap-2"><Globe className="h-4 w-4" /> English (US)</span>
        </div>
      </div>
    </footer>
  );
}
